<template>
  <b-form-group
    label="Parola"
    label-for="password"
  >
    <b-input-group class="input-group-merge">
      <b-form-input
        id="password"
        v-model="dataItem.password"
        :type="passwordFieldType"
        placeholder="Parola"
      />
      <b-input-group-append is-text>
        <feather-icon
          :icon="passwordToggleIcon"
          class="cursor-pointer"
          @click="togglePasswordVisibility"
        />
      </b-input-group-append>
      <b-input-group-append>
        <b-button
          variant="outline-secondary"
          size="sm"
          title="Güçlü rastgele şifre oluştur (8 karakter)"
          @click="generateRandomPassword"
        >
          <feather-icon
            icon="RefreshCwIcon"
            size="16"
          />
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </b-form-group>
</template>

<script>
import { localize } from 'vee-validate'
import {
  BFormGroup, BFormInput, BInputGroupAppend,
  BInputGroup, BButton,
} from 'bootstrap-vue'
// eslint-disable-next-line no-unused-vars
import { required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'

export default {
  name: 'UserName',
  components: {
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BButton,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      required,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    dataItem() {
      return this.$store.getters['users/dataItem']
    },
  },
  created() {
    localize('tr')
  },
  methods: {
    generateRandomPassword() {
      // Güçlü şifre oluşturma (8 karakter: büyük harf, küçük harf, rakam, özel karakter)
      this.passwordFieldType = 'text'
      const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      const lowercase = 'abcdefghijklmnopqrstuvwxyz'
      const numbers = '0123456789'
      const symbols = '!@#$%^&*()_+-=[]{}|;:,.<>?'

      // Her kategoriden en az bir karakter al
      let password = ''
      password += uppercase.charAt(Math.floor(Math.random() * uppercase.length))
      password += lowercase.charAt(Math.floor(Math.random() * lowercase.length))
      password += numbers.charAt(Math.floor(Math.random() * numbers.length))
      password += symbols.charAt(Math.floor(Math.random() * symbols.length))

      // Kalan 4 karakteri tüm karakterlerden rastgele seç
      const allChars = uppercase + lowercase + numbers + symbols
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < 4; i++) {
        password += allChars.charAt(Math.floor(Math.random() * allChars.length))
      }
      // Karakterleri karıştır
      password = password.split('').sort(() => Math.random() - 0.5).join('')

      this.dataItem.password = password
    },
  },
}
</script>

<style scoped>

</style>
